import { render, staticRenderFns } from "./RChipLabel.vue?vue&type=template&id=7b31ca79&lang=pug&"
import script from "./RChipLabel.vue?vue&type=script&lang=js&"
export * from "./RChipLabel.vue?vue&type=script&lang=js&"
import style0 from "./RChipLabel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RChipLabel.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib'
installComponents(component, {
  VChip,
})
